import { render, staticRenderFns } from "./PricingCardsMobile.vue?vue&type=template&id=2cc9ef09&"
import script from "./PricingCardsMobile.vue?vue&type=script&lang=js&"
export * from "./PricingCardsMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports